import 'chartjs-adapter-date-fns';

import { Component, Injector } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Chart, registerables } from 'chart.js';

import { RouterOutlet } from '@angular/router';
import { CentralServerService } from '@services/central-server.service';
import { WindowService } from '@services/window.service';
import { CONNECTOR_ALL_TYPES_MAP } from './shared/model/charging-stations.model';
import { AppInjector } from './annotations/app.injector';

const GENERIC_TITLE = 'VEV-IQ Platform';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent {
  public title = 'VEV-IQ';

  public constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private injector: Injector,
    private titleService: Title,
    private centralServerService: CentralServerService,
    private windowService: WindowService,
  ) {
    AppInjector.set(injector);
    this.centralServerService
      .getCurrentUserSubject()
      .pipe(takeUntilDestroyed())
      .subscribe((user) => {
        if (user?.tenantName && !this.windowService.isSuperTenant()) {
          this.titleService.setTitle(`${user.tenantName} | VEV-IQ`);
        } else {
          this.titleService.setTitle(GENERIC_TITLE);
        }
      });
    iconRegistry.addSvgIcon(
      'charging-socket',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/charging-socket.svg'),
    );
    iconRegistry.addSvgIcon('charger', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/charger.svg'));
    iconRegistry.addSvgIcon('socket', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/socket.svg'));
    iconRegistry.addSvgIcon('truck', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/truck.svg'));
    iconRegistry.addSvgIcon('battery', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/battery.svg'));
    iconRegistry.addSvgIcon('power', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/power.svg'));
    iconRegistry.addSvgIcon('clock', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/clock.svg'));
    iconRegistry.addSvgIcon('watch', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/watch.svg'));
    iconRegistry.addSvgIcon('file', sanitizer.bypassSecurityTrustResourceUrl('assets/img/icons/file.svg'));
    for (const connectorMap of CONNECTOR_ALL_TYPES_MAP) {
      if (connectorMap.svgIconName) {
        iconRegistry.addSvgIcon(
          connectorMap.svgIconName,
          sanitizer.bypassSecurityTrustResourceUrl(connectorMap.svgIconFile),
        );
      }
    }
    Chart.register(...registerables);
  }
}
